import { Link } from "react-router-dom";
import Seo from "../components/Seo";
import Breadcrumbs from "../components/Breadcrumbs";
import { WhatsAppButton } from "../components/CTAButtons";
import { BRAND } from "../data/content";
import { GUIDE_ARTICLES } from "../data/guides";
import { breadcrumbSchema, multiGraph } from "../components/Schema";
import { ArrowRight, Clock3 } from "lucide-react";

export default function Guides() {
  const crumbs = [{ label: "Home", href: "/" }, { label: "Guides" }];
  const entries = Object.entries(GUIDE_ARTICLES);
  return (
    <>
      <Seo
        title="Wellness guides for Bhubaneswar"
        description="Short, honest reading for anyone planning a spa visit in Bhubaneswar — pricing comparisons, massage style explainers and first-visit basics."
        path="/guides/"
        jsonLd={multiGraph(breadcrumbSchema(crumbs))}
      />
      <section className="content-hero section-pad narrow">
        <Breadcrumbs items={crumbs} />
        <p className="eyebrow">{BRAND.short}</p>
        <h1>Wellness guides.</h1>
        <p className="large-copy">
          Short, practical reading for anyone planning a spa visit in Bhubaneswar — written to help you ask
          better questions, not to sell you a package.
        </p>
        <WhatsAppButton label="Ask on WhatsApp" source="guides_index" testid="guides-whatsapp-cta" />
      </section>
      <section className="section-pad narrow">
        <div className="guide-grid">
          {entries.map(([slug, g], i) => (
            <Link to={`/guides/${slug}/`} key={slug} className="guide-card linked" data-testid={`guide-card-${i}`}>
              <span className="card-kicker"><Clock3 size={11} /> {g.read} read</span>
              <h3>{g.title}</h3>
              <p className="muted-small">{g.description.slice(0, 130)}…</p>
              <span className="text-link">Read guide <ArrowRight size={14} /></span>
            </Link>
          ))}
        </div>
      </section>
    </>
  );
}
